import { hasModulePermission, type PermissionLevelValue, type PermissionModule } from '@crm/shared';
import { useSession } from './use-session';

/** True quando o usuario logado alcanca o nivel exigido no modulo. */
export function useCan(module: PermissionModule, level: PermissionLevelValue = 'READ'): boolean {
  const { permissions } = useSession();

  if (!permissions) return false;

  return hasModulePermission(permissions, module, level);
}
